export const CSS_ZINDEX_DRAWER = 1000;
export const CSS_ZINDEX_NAVIGATOR_TABS = 202;
export const CSS_ZINDEX_MODEL_VIEWER_TOGGLE = 201;
export const CSS_ZINDEX_MODEL_VIEWER = 200;

export const PERMISSION_LEVEL_ADMIN = 900;
export const PERMISSION_LEVEL_EDIT = 600;
export const PERMISSION_LEVEL_VIEW = 300;
export const PERMISSION_LEVEL_EXTERNAL = 100;
